import content from "../language/ENGLISH.json";

const { homePageQuickBill } = content;

const {
  ecStatic1Title,
  ecStatic1Desc,
  ecStatic2Title,
  ecStatic2Desc,
  ecStatic2Tag,
  ecStatic3Title,
  ecStatic3Desc,
  ecStatic4Title,
  ecStatic4Desc,
  ecStatic4Tag,
  retailQ1,
  retailA1,
  retailQ2,
  retailA2,
  retailQ3,
  retailA3,
  retailQ4,
  retailA4,
  retailQ5,
  retailA5,
  retailQ6,
  retailA6,
  retailQ7,
  retailA7,
  retailQ8,
  retailA8,
  retailQ9,
  retailA9,
  retailQ10,
  retailA10,
  retailOutlet1,
  retailOutlet2,
  retailOutlet3,
  retailOutlet4,
  retailOutlet5,
  retailOutlet6,
  retailOutlet7,
  retailOutlet8,
} = content.retailIndustry;

const {
  inFeature1,
  inFeature1Desc,
  inFeature2,
  inFeature2Desc,
  inFeature3,
  inFeature3Desc,
  inFeature4,
  inFeature4Desc,
  inFeature5,
  inFeature5Desc,
  inFeature6,
  inFeature6Desc,
  inFeature7,
  inFeature7Desc,
  inFeature8,
  inFeature8Desc,
} = content.industryFeatures;

const {
  glimpseTitle,
  glimpse1Desc,
  glimpse2Desc,
  glimpse3Desc,
  glimpse4Desc,
  glimpse5Desc,
  glimpse6Desc,
  glimpse1BT1C,
  glimpse2BT1C,
  glimpse3BT1C,
  glimpse4BT1C,
  glimpse5BT1C,
  glimpse6BT1C,
  glimpse1BT2C,
  glimpse2BT2C,
  glimpse3BT2C,
  glimpse4BT2C,
  glimpse5BT2C,
  glimpse6BT2C,
  glimpse1BT2Name,
  glimpse2BT2Name,
  glimpse3BT2Name,
  glimpse4BT2Name,
  glimpse5BT2Name,
  glimpse6BT2Name,
  glimpse1BT2Info1,
  glimpse2BT2Info1,
  glimpse3BT2Info1,
  glimpse4BT2Info1,
  glimpse5BT2Info1,
  glimpse6BT2Info1,
  glimpse1BT2Info2,
  glimpse2BT2Info2,
  glimpse3BT2Info2,
  glimpse4BT2Info2,
  glimpse5BT2Info2,
  glimpse6BT2Info2,
} = content.industryGlimpses;

const {
  ResecStatic1Desc,
  ResecStatic1Title,
  ResecStatic1Tag,
  ResecStatic2Desc,
  ResecStatic2Title,
  ResecStatic2Tag,
  ResecStatic3Desc,
  ResecStatic3Title,
  ResecStatic3Tag,
  ResecStatic4Desc,
  ResecStatic4Title,
  ResecStatic4Tag,
  ResOutlet1,
  ResOutlet2,
  ResOutlet3,
  ResOutlet4,
  ResOutlet5,
  ResOutlet6,
  ResOutlet7,
  ResOutlet8,
  ResQ1,
  ResA1,
  ResQ2,
  ResA2Pt1,
  ResA2Pt2,
  ResA2Pt3,
  ResA2Pt4,
  ResA2Pt5,
  ResQ3,
  ResA3,
  ResQ4,
  ResA4,
  ResQ5,
  ResA5,
  ResQ6,
  ResA6,
  ResQ7,
  ResA7,
  ResQ8,
  ResA8,
  ResQ9,
  ResA9,
  ResQ10,
  ResA10,
} = content.restaurantIndustry;

const {
  GroQ1,
  GroA1,
  GroQ2,
  GroA2,
  GroQ3,
  GroA3,
  GroQ4,
  GroA4,
  GroQ5,
  GroA5,
  GroQ6,
  GroA6,
  GroQ7,
  GroA7,
  GroQ8,
  GroA8,
  GroQ9,
  GroA9,
  GroQ10,
  GroA10,
  groEcstatic1Title,
  groEcstatic2Title,
  groEcstatic3Title,
  groEcstatic4Title,
  groEcstatic1Desc,
  groEcstatic2Desc,
  groEcstatic3Desc,
  groEcstatic4Desc,
  groEcstatic1Tag,
  groEcstatic2Tag,
  groEcstatic3Tag,
  groEcstatic4Tag,
  groOT1,
  groOT2,
  groOT3,
  groOT4,
  groOT5,
  groOT6,
  groOT7,
  groOT8,
} = content.groceryIndustry;

const {
  salonEcstaticTitle1,
  salonEcstaticDesc1,
  salonEcstaticTag1,
  salonEcstaticTitle2,
  salonEcstaticDesc2,
  salonEcstaticTag2,
  salonEcstaticTitle3,
  salonEcstaticDesc3,
  salonEcstaticTag3,
  salonOT1,
  salonOT2,
  salonOT3,
  salonOT4,
  salonOT5,
  salonOT6,
  SalonQ1,
  SalonA1,
  SalonQ2,
  SalonA2,
  SalonA2P1,
  SalonA2P2,
  SalonA2P3,
  SalonA2P4,
  SalonA2P5,
  SalonA2P6,
  SalonQ3,
  SalonA3,
  SalonQ4,
  SalonA4,
  SalonQ5,
  SalonA5,
  SalonQ6,
  SalonA6,
  SalonQ7,
  SalonA7,
  SalonQ8,
  SalonA8,
  SalonQ9,
  SalonA9,
  SalonQ10,
  SalonA10,
  salonInFeature1,
  salonInFeature1Desc,
  salonInFeature4,
  salonInFeature4Desc,
} = content.salonIndustry;

const {
  elecEcstaticTitle1,
  elecEcstaticTitle2,
  elecEcstaticTitle3,
  elecEcstaticTitle4,
  elecEcstaticDesc1,
  elecEcstaticDesc2,
  elecEcstaticDesc3,
  elecEcstaticDesc4,
  elecEcstaticTag1,
  elecEcstaticTag2,
  elecEcstaticTag3,
  elecEcstaticTag4,
  elecOT1,
  elecOT2,
  elecOT3,
  elecOT4,
  ElecQ1,
  ElecA1,
  ElecQ2,
  ElecA2,
  ElecQ3,
  ElecA3,
  ElecQ4,
  ElecA4,
  ElecQ5,
  ElecA5,
  ElecQ6,
  ElecA6,
  ElecQ7,
  ElecA7,
  ElecQ8,
  ElecA8,
} = content.electronicsIndustry;

const { inventoryManagement } = content.contactSales;

export const reatilEcstatic = [
  {
    id: 1,
    icon: "/assets/industry/retail/ecstatic-icon1.svg",
    iconAlt: "asdf",
    title: ecStatic1Title,
    fullText: ecStatic1Desc,
    image: "/assets/industry/retail/ecstatic-img1.webp",
    imageAlt: "asdf",
    bgColor: "#8AE4F626",
    tag: homePageQuickBill,
    tagBG: "#8ae4f669",
    tagBorder: "#00c3f7",
  },
  {
    id: 2,
    icon: "/assets/industry/retail/ecstatic-icon2.svg",
    iconAlt: "asdf",
    title: ecStatic2Title,
    fullText: ecStatic2Desc,
    image: "/assets/industry/retail/ecstatic-img2.webp",
    imageAlt: "asdf",
    bgColor: "#FDACAC26",
    tag: ecStatic2Tag,
    tagBG: "#FFC3C3",
    tagBorder: "#FF9393",
  },
  {
    id: 3,
    icon: "/assets/industry/retail/ecstatic-icon3.svg",
    iconAlt: "asdf",
    title: ecStatic3Title,
    fullText: ecStatic3Desc,
    image: "/assets/industry/retail/ecstatic-img3.webp",
    imageAlt: "asdf",
    bgColor: "#F8D37826",
    tag: inventoryManagement,
    tagBG: "#f8d378",
    tagBorder: "#ffb500",
  },
  {
    id: 4,
    icon: "/assets/industry/retail/ecstatic-icon4.svg",
    iconAlt: "asdf",
    title: ecStatic4Title,
    fullText: ecStatic4Desc,
    image: "/assets/industry/retail/ecstatic-img4.webp",
    imageAlt: "asdf",
    bgColor: "#88F0D526",
    tag: ecStatic4Tag,
    tagBG: "#87F1D5",
    tagBorder: "#03BF8D",
  },
];

export const retailFAQ = [
  {
    para: <span style={{ width: "90%" }}>{retailQ1}</span>,
    des: retailA1,
    id: 1,
    activeIndex: 1,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ2}</span>,
    des: retailA2,
    id: 2,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ3}</span>,
    des: retailA3,
    id: 3,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ4}</span>,
    des: retailA4,
    id: 4,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ5}</span>,
    des: retailA5,
    id: 5,
    activeIndex: 0,
  },

  {
    para: <span style={{ width: "90%" }}>{retailQ6}</span>,
    des: retailA6,
    id: 6,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ7}</span>,
    des: retailA7,
    id: 7,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ8}</span>,
    des: retailA8,
    id: 8,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ9}</span>,
    des: retailA9,
    id: 9,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{retailQ10}</span>,
    des: retailA10,
    id: 10,
    activeIndex: 0,
  },
];

export const retailOutletTypes = [
  {
    id: 1,
    image: "/assets/industry/retail/fashion.webp",
    bgColor: "#8AE4F667",
    title: retailOutlet1,
    altText: "fashion and apparel",
    link: "/retail/fashion-apparel-pos-billing-software",
  },
  {
    id: 2,
    image: "/assets/industry/retail/footwear.webp",
    bgColor: "#2A6AB421",
    title: retailOutlet5,
    altText: "footwear",
    link: "/retail/footwear-pos-billing-software",
  },
  {
    id: 3,
    image: "/assets/industry/retail/cosmetics.webp",
    bgColor: "#F68A8A67",
    title: retailOutlet4,
    altText: "cosmetics",
    link: "/retail/cosmetics-pos-billing-software",
  },
  {
    id: 4,
    image: "/assets/industry/retail/home.webp",
    bgColor: "#FFFDC971",
    title: retailOutlet6,
    altText: "home and living",
    link: "/Industries/retail-pos-billing-software",
  },
  {
    id: 5,
    image: "/assets/industry/retail/accessories.webp",
    bgColor: "#EEC9FF71",
    title: retailOutlet2,
    altText: "accessories",
    link: "/Industries/retail-pos-billing-software",
  },
  {
    id: 6,
    image: "/assets/industry/retail/carts.webp",
    bgColor: "#F6C88A67",
    title: retailOutlet3,
    altText: "carts and kiosks",
    link: "/Industries/retail-pos-billing-software",
  },
  {
    id: 7,
    image: "/assets/industry/retail/brewery.webp",
    bgColor: "#8A92F638",
    title: retailOutlet7,
    altText: "brewery store",
    link: "/Industries/retail-pos-billing-software",
  },
  {
    id: 8,
    image: "/assets/industry/retail/petstore.webp",
    bgColor: "#9BF68A67",
    title: retailOutlet8,
    altText: "pet stores",
    link: "/Industries/retail-pos-billing-software",
  },
];

export const features = [
  {
    id: 1,
    icon: "/assets/Other_Feature_HomePage/Product_Catalog.svg",
    title: inFeature1,
    desc: inFeature1Desc,
  },
  {
    id: 2,
    icon: "/assets/Other_Feature_HomePage/Reports.svg",
    title: inFeature2,
    desc: inFeature2Desc,
  },
  {
    id: 3,
    icon: "/assets/Other_Feature_HomePage/Payments.svg",
    title: inFeature3,
    desc: inFeature3Desc,
  },
  {
    id: 4,
    icon: "/assets/Other_Feature_HomePage/Bulk_Data_Managemnet.svg",
    title: inFeature4,
    desc: inFeature4Desc,
  },
  {
    id: 5,
    icon: "/assets/Other_Feature_HomePage/Offline_Mode.svg",
    title: inFeature5,
    desc: inFeature5Desc,
  },
  {
    id: 6,
    icon: "/assets/Other_Feature_HomePage/Roles_and_Permissions.svg",
    title: inFeature6,
    desc: inFeature6Desc,
  },
  {
    id: 7,
    icon: "/assets/Other_Feature_HomePage/Multiple_Currencies.svg",
    title: inFeature7,
    desc: inFeature7Desc,
  },
  {
    id: 8,
    icon: "/assets/Other_Feature_HomePage/Promotion&Discount.svg",
    title: inFeature8,
    desc: inFeature8Desc,
  },
];

export const glimpses = [
  {
    id: 1,
    bgColor: "#EDFBFE",
    growColor: "#8AE4F6",
    textColor: "#EDFBFE",
    companyLogo: "/assets/industry/glimpses/hul.png",
    companyLogoWidth: "29rem",
    companyLogoHeight: "7rem",
    altText: "HUL logo",
    title: glimpseTitle,
    desc: glimpse2Desc,
    blackTile1: {
      digit: 4000,
      content: glimpse2BT1C,
    },
    blackTile2: {
      content: glimpse2BT2C,
      name: glimpse2BT2Name,
      info1: glimpse2BT2Info1,
      info2: glimpse2BT2Info2,
    },
  },
  {
    id: 2,
    bgColor: "#E5F7EC",
    growColor: "#44D37B",
    textColor: "#E5F7EC",
    companyLogo: "/assets/industry/glimpses/heineken.png",
    companyLogoWidth: "22rem",
    companyLogoHeight: "5rem",
    altText: "heineken logo",
    title: glimpseTitle,
    desc: glimpse1Desc,
    blackTile1: {
      digit: 314,
      content: glimpse1BT1C,
    },
    blackTile2: {
      content: glimpse1BT2C,
      name: glimpse1BT2Name,
      info1: glimpse1BT2Info1,
      info2: glimpse1BT2Info2,
    },
  },
  {
    id: 3,
    bgColor: "#C7A32D1A",
    growColor: "#E69F2C",
    textColor: "#dacfad",
    companyLogo: "/assets/industry/glimpses/cococart.png",
    companyLogoWidth: "22rem",
    companyLogoHeight: "4rem",
    altText: "cococart logo",
    title: glimpseTitle,
    desc: glimpse3Desc,
    blackTile1: {
      digit: 100,
      content: glimpse3BT1C,
    },
    blackTile2: {
      content: glimpse3BT2C,
      name: glimpse3BT2Name,
      info1: glimpse3BT2Info1,
      info2: glimpse3BT2Info2,
    },
  },
  {
    id: 4,
    bgColor: "#FDACAC26",
    growColor: "#FD7B80",
    textColor: "#f3d3d3",
    companyLogo: "/assets/industry/glimpses/bridgestone.png",
    companyLogoWidth: "25rem",
    companyLogoHeight: "3rem",
    altText: "bridgestone",
    title: glimpseTitle,
    desc: glimpse4Desc,
    blackTile1: {
      digit: 550,
      content: glimpse4BT1C,
    },
    blackTile2: {
      content: glimpse4BT2C,
      name: glimpse4BT2Name,
      info1: glimpse4BT2Info1,
      info2: glimpse4BT2Info2,
    },
  },
  {
    id: 5,
    bgColor: "#2A6AB41A",
    growColor: "#6FB2FF",
    textColor: "#bacfe8",
    companyLogo: "/assets/industry/glimpses/irctc.png",
    companyLogoWidth: "40rem",
    companyLogoHeight: "10rem",
    altText: "IRCTC",
    title: glimpseTitle,
    desc: glimpse5Desc,
    blackTile1: {
      digit: 750,
      content: glimpse5BT1C,
    },
    blackTile2: {
      content: glimpse5BT2C,
      name: glimpse5BT2Name,
      info1: glimpse5BT2Info1,
      info2: glimpse5BT2Info2,
    },
  },
  {
    id: 6,
    bgColor: "#FFF7E5",
    growColor: "#F0B530",
    textColor: "#FFE9B7",
    companyLogo: "/assets/industry/glimpses/tajSats.png",
    companyLogoWidth: "30rem",
    companyLogoHeight: "7rem",
    logoMarginBottom: "2rem",
    altText: "Taj stats",
    title: glimpseTitle,
    desc: glimpse6Desc,
    blackTile1: {
      digit: 15,
      content: glimpse6BT1C,
    },
    blackTile2: {
      content: glimpse6BT2C,
      name: glimpse6BT2Name,
      info1: glimpse6BT2Info1,
      info2: glimpse6BT2Info2,
    },
  },
];

// -------restaurant-------

export const restaurantEcstatic = [
  {
    id: 1,
    icon: "/assets/industry/retail/ecstatic-icon1.svg",
    iconAlt: "asdf",
    title: ResecStatic1Title,
    fullText: ResecStatic1Desc,
    image: "/assets/industry/restaurant/ecstatic-img1.webp",
    imageAlt: "asdf",
    bgColor: "#8AE4F626",
    tag: ResecStatic1Title,
    tagBG: "#8ae4f669",
    tagBorder: "#00c3f7",
  },
  {
    id: 2,
    icon: "/assets/industry/retail/ecstatic-icon4.svg",
    iconAlt: "asdf",
    title: ResecStatic4Title,
    fullText: ResecStatic4Desc,
    image: "/assets/industry/restaurant/ecstatic-img2.webp",
    imageAlt: "asdf",
    bgColor: "#88F0D526",
    tag: ResecStatic4Tag,
    tagBG: "#87F1D5",
  },
  {
    id: 3,
    icon: "/assets/industry/restaurant/ecstatic-icon3.svg",
    iconAlt: "asdf",
    title: ResecStatic3Title,
    fullText: ResecStatic3Desc,
    image: "/assets/industry/restaurant/ecstatic-img3.webp",
    imageAlt: "asdf",
    bgColor: "#FDACAC26",
    tag: ResecStatic3Tag,
    tagBG: "#FFC3C3",
  },
  {
    id: 4,
    icon: "/assets/industry/retail/ecstatic-icon3.svg",
    iconAlt: "asdf",
    title: ResecStatic2Title,
    fullText: ResecStatic2Desc,
    image: "/assets/industry/retail/ecstatic-img3.webp",
    imageAlt: "asdf",
    bgColor: "#F8D37826",
    tag: ResecStatic2Tag,
    tagBG: "#f8d378",
  },
];

export const restaurantOutletTypes = [
  {
    id: 1,
    image: "/assets/industry/restaurant/fine-dine.webp",
    bgColor: "#8AE4F667",
    title: ResOutlet1,
    altText: "fine dine",
    link: "/restaurants/fine-dine-pos-billing-software",
  },
  {
    id: 2,
    image: "/assets/industry/restaurant/quick-service.webp",
    bgColor: "#F68A8A67",
    title: ResOutlet8,
    altText: "quick service",
    link: "/restaurants/quick-service-restaurants-pos-billing-software",
  },
  {
    id: 3,
    image: "/assets/mPOS/foodTruck.webp",
    bgColor: "#EEC9FF71",
    title: "FOOD TRUCKS",
    altText: "food trucks",
    link: "/restaurants/food-truck-pos-billing-software",
  },
  {
    id: 4,
    image: "/assets/industry/restaurant/sweets.webp",
    bgColor: "#F6C88A67",
    title: ResOutlet3,
    altText: "sweet shops",
    link: "/Industries/restaurant-pos-billing-software",
  },
  {
    id: 5,
    image: "/assets/industry/restaurant/bar&pubs.webp",
    bgColor: "#2A6AB421",
    title: ResOutlet4,
    altText: "bar and pubs",
    link: "/Industries/restaurant-pos-billing-software",
  },
  {
    id: 6,
    image: "/assets/industry/restaurant/train-catering.webp",
    bgColor: "#FFFDC971",
    title: ResOutlet5,
    altText: "catering",
    link: "/Industries/restaurant-pos-billing-software",
  },
  {
    id: 7,
    image: "/assets/industry/restaurant/cloud-kitchen.webp",
    bgColor: "#8A92F638",
    title: ResOutlet6,
    altText: "cloud kitchen",
    link: "/Industries/restaurant-pos-billing-software",
  },
  {
    id: 8,
    image: "/assets/industry/restaurant/food-court.webp",
    bgColor: "#9BF68A67",
    title: ResOutlet7,
    altText: "food courts",
    link: "/Industries/restaurant-pos-billing-software",
  },
];

export const restaurantFAQ = [
  {
    para: <span style={{ width: "90%" }}>{ResQ1}</span>,
    des: "QueueBuster Restaurant POS Billing Software is a comprehensive point-of-sale solution designed specifically for restaurants. It streamlines the billing process, manages orders, and inventory, and provides insightful analytics to enhance restaurant operations.",
    id: 1,
    activeIndex: 1,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ2}</span>,
    des: "QueueBuster Restaurant POS offers order management, billing and invoicing, inventory management, reporting and analytics, and seamless integration with payment gateways and other software.",
    id: 2,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ3}</span>,
    des: ResA3,
    id: 3,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ4}</span>,
    des: ResA4,
    id: 4,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ5}</span>,
    des: ResA5,
    id: 5,
    activeIndex: 0,
  },

  {
    para: <span style={{ width: "90%" }}>{ResQ6}</span>,
    des: ResA6,
    id: 6,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ7}</span>,
    des: ResA7,
    id: 7,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ8}</span>,
    des: ResA8,
    id: 8,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ9}</span>,
    des: ResA9,
    id: 9,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ResQ10}</span>,
    des: ResA10,
    id: 10,
    activeIndex: 0,
  },
];

// ---------grocery industry-----------

export const groceryEcstatic = [
  {
    id: 1,
    icon: "/assets/industry/grocery/barcode.svg",
    iconAlt: "barcode",
    title: groEcstatic1Title,
    fullText: groEcstatic1Desc,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/barcode.webp",
    imageAlt: "asdf",
    bgColor: "#8AE4F626",
    tag: groEcstatic1Tag,
    tagBG: "#8ae4f669",
  },
  {
    id: 2,
    icon: "/assets/industry/retail/ecstatic-icon4.svg",
    iconAlt: "asdf",
    title: groEcstatic4Title,
    fullText: groEcstatic4Desc,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/sell-anytime.webp",
    imageAlt: "asdf",
    bgColor: "#88F0D526",
    tag: groEcstatic4Tag,
    tagBG: "#87F1D5",
  },
  {
    id: 3,
    icon: "/assets/industry/retail/ecstatic-icon2.svg",
    iconAlt: "asdf",
    title: groEcstatic3Title,
    fullText: groEcstatic3Desc,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/crm.webp",
    imageAlt: "asdf",
    bgColor: "#FDACAC26",
    tag: groEcstatic3Tag,
    tagBG: "#FFC3C3",
  },
  {
    id: 4,
    icon: "/assets/industry/retail/ecstatic-icon3.svg",
    iconAlt: "asdf",
    fullText: groEcstatic2Desc,
    title: groEcstatic2Title,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/inventory.webp",
    imageAlt: "asdf",
    bgColor: "#F8D37826",
    tag: groEcstatic2Tag,
    tagBG: "#f8d378",
  },
];

export const groceryOutletTypes = [
  {
    id: 1,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/kirana-store.webp",
    bgColor: "#8AE4F667",
    title: groOT1,
    altText: "Kirana Shops",
    link: "/grocery/kirana-stores-pos-billing-software",
  },
  {
    id: 2,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/super-market.webp",
    bgColor: "#EEC9FF71",
    title: groOT2,
    altText: "super market",
    link: "/grocery/supermarket-pos-billing-software",
  },
  {
    id: 3,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/fmcg.webp",
    bgColor: "#F6C88A67",
    title: groOT3,
    altText: "fmcg",
    link: "/grocery/fmcg-pos-billing-software",
  },
  {
    id: 4,
    image: "/assets/industry/grocery/dryfruits.webp",
    bgColor: "#2A6AB421",
    title: groOT4,
    altText: "dryfruits",
    link: "/grocery/dryfruits-pos-billing-software",
  },
  {
    id: 5,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/hyper-markets.webp",
    bgColor: "#FFFDC971",
    title: groOT5,
    altText: "hyper markets",
    link: "/grocery/hypermarkets-pos-billing-software",
  },
  {
    id: 6,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/convenience-store.webp",
    bgColor: "#8A92F638",
    title: groOT6,
    altText: "convenience store",
    link: "/Industries/grocery-pos-billing-software",
  },
  {
    id: 7,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/departmental-store.webp",
    bgColor: "#9BF68A67",
    title: groOT7,
    altText: "departmental stores",
    link: "/Industries/grocery-pos-billing-software",
  },
  {
    id: 8,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/grocery/veg-store.webp",
    bgColor: "#F68A8A67",
    title: groOT8,
    altText: "vegetable store",
    link: "/Industries/grocery-pos-billing-software",
  },
];

export const groceryFAQ = [
  {
    para: <span style={{ width: "90%" }}>{GroQ1}</span>,
    des: GroA1,
    id: 1,
    activeIndex: 1,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ2}</span>,
    des: GroA2,
    id: 2,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ3}</span>,
    des: GroA3,
    id: 3,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ4}</span>,
    des: GroA4,
    id: 4,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ5}</span>,
    des: GroA5,
    id: 5,
    activeIndex: 0,
  },

  {
    para: <span style={{ width: "90%" }}>{GroQ6}</span>,
    des: GroA6,
    id: 6,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ7}</span>,
    des: GroA7,
    id: 7,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ8}</span>,
    des: GroA8,
    id: 8,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ9}</span>,
    des: GroA9,
    id: 9,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{GroQ10}</span>,
    des: GroA10,
    id: 10,
    activeIndex: 0,
  },
];

// -------spa and salon---------
export const salonEcstatic = [
  {
    id: 1,
    icon: "/assets/industry/spa&salon/appointment.svg",
    iconAlt: "barcode",
    title: salonEcstaticTitle1,
    fullText: salonEcstaticDesc1,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/appointment-booking.webp",
    imageAlt: "asdf",
    bgColor: "#8AE4F626",
    tag: salonEcstaticTag1,
    tagBG: "#8ae4f669",
  },
  {
    id: 3,
    icon: "/assets/industry/retail/ecstatic-icon2.svg",
    iconAlt: "asdf",
    title: salonEcstaticTitle3,
    fullText: salonEcstaticDesc3,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/membership.webp",
    imageAlt: "asdf",
    bgColor: "#FDACAC26",
    tag: salonEcstaticTag3,
    tagBG: "#FFC3C3",
  },
  {
    id: 2,
    icon: "/assets/industry/retail/ecstatic-icon4.svg",
    iconAlt: "asdf",
    title: salonEcstaticTitle2,
    fullText: salonEcstaticDesc2,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/estore.webp",
    imageAlt: "asdf",
    bgColor: "#88F0D526",
    tag: salonEcstaticTag2,
    tagBG: "#87F1D5",
  },
];

export const salonOutletTypes = [
  {
    id: 1,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/specialty-spas.webp",
    bgColor: "#8AE4F667",
    title: salonOT1,
    altText: "specialty spas",
    link: "/spa-and-salon/spa-pos-billing-software",
  },
  {
    id: 2,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/gyms.webp",
    bgColor: "#EEC9FF71",
    title: salonOT2,
    altText: "gym",
    link: "/spa-and-salon/gym-pos-billing-software",
  },
  {
    id: 5,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/dermatoligist.webp",
    bgColor: "#FFFDC971",
    title: salonOT5,
    altText: "dermatologist",
    link: "/spa-and-salon/dermatology-pos-billing-software",
  },
  {
    id: 6,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/dental-clinic.webp",
    bgColor: "#8A92F638",
    title: salonOT6,
    altText: "dentist",
    link: "/spa-and-salon/dentist-pos-billing-software",
  },
  {
    id: 3,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/salon-shop.webp",
    bgColor: "#F6C88A67",
    title: salonOT3,
    altText: "salon",
    link: "/Industries/spa-and-salon-pos-billing-software",
  },
  {
    id: 4,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/spa/yoga-center.webp",
    bgColor: "#2A6AB421",
    title: salonOT4,
    altText: "yoga",
    link: "/Industries/spa-and-salon-pos-billing-software",
  },
];

export const salonFAQ = [
  {
    para: <span style={{ width: "90%" }}>{SalonQ1}</span>,
    des: SalonA1,
    id: 1,
    activeIndex: 1,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ2}</span>,
    des: "QueueBuster POS is a comprehensive solution designed for the spa and salon industry. It offers features such as appointment scheduling and booking management, inventory management for beauty products, employee management and scheduling, billing and invoicing, customer relationship management (CRM), and reporting etc.",
    id: 2,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ3}</span>,
    des: SalonA3,
    id: 3,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ4}</span>,
    des: SalonA4,
    id: 4,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ5}</span>,
    des: SalonA5,
    id: 5,
    activeIndex: 0,
  },

  {
    para: <span style={{ width: "90%" }}>{SalonQ6}</span>,
    des: SalonA6,
    id: 6,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ7}</span>,
    des: SalonA7,
    id: 7,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ8}</span>,
    des: SalonA8,
    id: 8,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ9}</span>,
    des: SalonA9,
    id: 9,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{SalonQ10}</span>,
    des: SalonA10,
    id: 10,
    activeIndex: 0,
  },
];

export const salonFeatures = [
  {
    id: 1,
    icon: "/assets/Other_Feature_HomePage/Product_Catalog.svg",
    title: salonInFeature1,
    desc: salonInFeature1Desc,
  },
  {
    id: 2,
    icon: "/assets/Other_Feature_HomePage/Reports.svg",
    title: inFeature2,
    desc: inFeature2Desc,
  },
  {
    id: 3,
    icon: "/assets/Other_Feature_HomePage/Payments.svg",
    title: inFeature3,
    desc: inFeature3Desc,
  },
  {
    id: 4,
    icon: "/assets/Other_Feature_HomePage/Bulk_Data_Managemnet.svg",
    title: salonInFeature4,
    desc: salonInFeature4Desc,
  },
  {
    id: 5,
    icon: "/assets/Other_Feature_HomePage/Offline_Mode.svg",
    title: inFeature5,
    desc: inFeature5Desc,
  },
  {
    id: 6,
    icon: "/assets/Other_Feature_HomePage/Roles_and_Permissions.svg",
    title: inFeature6,
    desc: inFeature6Desc,
  },
  {
    id: 7,
    icon: "/assets/Other_Feature_HomePage/Multiple_Currencies.svg",
    title: inFeature7,
    desc: inFeature7Desc,
  },
  {
    id: 8,
    icon: "/assets/Other_Feature_HomePage/Promotion&Discount.svg",
    title: inFeature8,
    desc: inFeature8Desc,
  },
];

// -------electronics industry---------
export const electronicsEcstatic = [
  {
    id: 1,
    icon: "/assets/industry/spa&salon/appointment.svg",
    iconAlt: "barcode",
    title: elecEcstaticTitle1,
    fullText: elecEcstaticDesc1,
    image: "/assets/industry/electronics/bill.webp",
    imageAlt: "asdf",
    bgColor: "#8AE4F626",
    height: "24rem",
    mobileHeight: "23rem",
    tag: elecEcstaticTag1,
    tagBG: "#8ae4f669",
    // imgHeight: "288px",
    // imgwidth: "338px",
  },
  {
    id: 2,
    icon: "/assets/industry/retail/ecstatic-icon4.svg",
    iconAlt: "asdf",
    title: elecEcstaticTitle2,
    fullText: elecEcstaticDesc2,
    image: "/assets/industry/electronics/estore.webp",
    imageAlt: "asdf",
    bgColor: "#88F0D526",
    height: "24rem",
    mobileHeight: "23rem",
    tag: elecEcstaticTag2,
    tagBG: "#87F1D5",
    // imgHeight: "288px",
    // imgwidth: "338px",
  },
  {
    id: 3,
    icon: "/assets/industry/retail/ecstatic-icon2.svg",
    iconAlt: "asdf",
    title: elecEcstaticTitle3,
    fullText: elecEcstaticDesc3,
    image: "/assets/industry/electronics/emi1.webp",
    imageAlt: "asdf",
    bgColor: "#FDACAC26",
    height: "24rem",
    mobileHeight: "23rem",
    tag: elecEcstaticTag3,
    tagBG: "#FFC3C3",
    // imgHeight: "288px",
    // imgwidth: "338px",
  },
  {
    id: 4,
    icon: "/assets/industry/retail/ecstatic-icon3.svg",
    iconAlt: "asdf",
    title: elecEcstaticTitle4,
    fullText: elecEcstaticDesc4,
    image: "/assets/industry/electronics/attri.webp",
    imageAlt: "asdf",
    bgColor: "#F8D37826",
    height: "24rem",
    mobileHeight: "23rem",
    tag: elecEcstaticTag4,
    tagBG: "#f8d378",
    // imgHeight: "288px",
    // imgwidth: "338px",
  },
];

export const electronicsOutletTypes = [
  {
    id: 1,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/electronics/electronic-showroom.webp",
    bgColor: "#F6C88A67",
    title: elecOT3,
    altText: "electronics",
    link: "/electronics/electronics-showroom-pos-billing-software",
  },
  {
    id: 2,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/electronics/home-appliances.webp",
    bgColor: "#EEC9FF71",
    title: elecOT2,
    altText: "home appliances",
    link: "/electronics/home-appliances-pos-billing-software",
  },
  {
    id: 3,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/electronics/mobile-shop.webp",
    bgColor: "#8AE4F667",
    title: elecOT1,
    altText: "mobile shop",
    link: "/electronics/mobile-accessories-pos-billing-software",
  },
  {
    id: 4,
    image:
      "https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/electronics/computer-hardware.webp",
    bgColor: "#2A6AB421",
    title: elecOT4,
    altText: "computer hardware",
    link: "/electronics/computer-hardware-pos-billing-software",
  },
];

export const electronicsFAQ = [
  {
    para: <span style={{ width: "90%" }}>{ElecQ1}</span>,
    des: ElecA1,
    id: 1,
    activeIndex: 1,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ2}</span>,
    des: ElecA2,
    id: 2,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ3}</span>,
    des: ElecA3,
    id: 3,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ4}</span>,
    des: ElecA4,
    id: 4,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ5}</span>,
    des: ElecA5,
    id: 5,
    activeIndex: 0,
  },

  {
    para: <span style={{ width: "90%" }}>{ElecQ6}</span>,
    des: ElecA6,
    id: 6,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ7}</span>,
    des: ElecA7,
    id: 7,
    activeIndex: 0,
  },
  {
    para: <span style={{ width: "90%" }}>{ElecQ8}</span>,
    des: ElecA8,
    id: 8,
    activeIndex: 0,
  },
];

export const hardwareFaq = [
  {
    para: (
      <span style={{ width: "90%" }}>
        Can I use QueueBuster POS with my existing Android device?
      </span>
    ),
    des: "QueueBuster POS is designed to seamlessly integrate with all Android devices, so you can use your existing hardware without any issues.",
    id: 1,
    activeIndex: 1,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        Do I need to purchase specialized POS terminals for QueueBuster POS to
        work?
      </span>
    ),
    des: "No, QueueBuster POS is compatible with a wide range of Android devices, including smartphones and tablets, so you don't need to invest in specialized POS terminals unless you prefer to.",
    id: 2,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        Can I connect QueueBuster POS to external devices like barcode scanners
        or printers?
      </span>
    ),
    des: "QueueBuster POS supports compatibility with various peripheral devices such as barcode scanners, printers, and cash drawers, allowing you to customize your POS setup according to your business needs.",
    id: 3,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        I have multiple locations. Can I use different Android devices at each
        location with QueueBuster POS?
      </span>
    ),
    des: "Yes, QueueBuster POS offers versatile compatibility, allowing you to use different Android devices at each location while still ensuring seamless integration and consistent performance.",
    id: 4,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What if I upgrade my Android device in the future? Will QueueBuster POS
        still work?
      </span>
    ),
    des: "QueueBuster POS is designed to be future-proof, so if you upgrade your Android device, you can easily transfer your QueueBuster POS setup without any disruptions to your business operations.",
    id: 5,
    activeIndex: 0,
  },

  {
    para: (
      <span style={{ width: "90%" }}>
        Does QueueBuster POS support payment processing?
      </span>
    ),
    des: "QB supports various payment methods, including UPI, credit card payments, and cash transactions using industry-leading payment integrations, ensuring smooth and secure payment processing for your customers.",
    id: 6,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        Can I use QueueBuster POS in offline mode if my internet connection is
        unreliable?
      </span>
    ),
    des: "Certainly, it offers offline functionality, allowing you to continue processing transactions even if your internet connection is temporarily unavailable. Once the connection is restored, QueueBuster POS will automatically sync the data.",
    id: 7,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        I run a restaurant. Does QueueBuster POS support kitchen display systems
        for order management?
      </span>
    ),
    des: "Our Android solution is compatible with kitchen display systems, enabling real-time order management and improving kitchen efficiency in restaurants.",
    id: 8,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        Do I need to install any additional software or drivers to use
        QueueBuster POS with external devices?
      </span>
    ),
    des: "No, QueueBuster POS is designed to be user-friendly and hassle-free. You won't need to install any additional software or drivers to use QueueBuster POS with external devices—it's plug-and-play.",
    id: 9,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        I operate a small retail shop. Will QueueBuster POS be too complex for
        my needs?
      </span>
    ),
    des: "Not at all. QueueBuster POS offers a simple and intuitive interface, making it easy for businesses of all sizes to manage their operations efficiently. Whether you're a small retail shop or a large enterprise, QueueBuster POS is tailored to meet your needs.",
    id: 10,
    activeIndex: 0,
  },
];

export const softwareFaq = [
  {
    para: (
      <span style={{ width: "90%" }}>
        How does QueueBuster integrate with Microsoft Dynamics, and what
        benefits does it offer?
      </span>
    ),
    des: "QueueBuster integrates with Microsoft Dynamics to streamline sales processes, gain real-time insights, improve collaboration, and scale business operations seamlessly.",
    id: 1,
    activeIndex: 1,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What are the key features of integrating QueueBuster with Zoho, and how
        does it enhance business operations?
      </span>
    ),
    des: "Integrating QueueBuster with Zoho enhances customer engagement, simplifies workflows, automates processes, and provides real-time data and analytics for business growth.",
    id: 2,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does QueueBuster's integration with Gray Matter optimize inventory
        management, and what are the advantages?
      </span>
    ),
    des: "QueueBuster integrated with Gray Matter optimizes inventory control, improves supply chain visibility, automates tasks, and provides actionable insights for better decision-making.",
    id: 3,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What benefits does integrating QueueBuster with Shopify bring for online
        stores, and how does it boost sales?
      </span>
    ),
    des: "Integrating QueueBuster with Shopify expands online presence, enhances the shopping experience, centralizes inventory management, and boosts sales through multiple channels.",
    id: 4,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does QueueBuster's integration with Zomato and Swiggy streamline
        food delivery operations, and what customer benefits does it offer?
      </span>
    ),
    des: "QueueBuster integrated with Zomato and Swiggy streamlines order processing, real-time tracking, and multiple payment options, and enhances customer satisfaction with efficient service.",
    id: 5,
    activeIndex: 0,
  },

  {
    para: (
      <span style={{ width: "90%" }}>
        What are the advantages of integrating QueueBuster with Tally for
        accounting processes, and how does it ensure compliance?
      </span>
    ),
    des: "Integrating QueueBuster with Tally simplifies accounting, generates accurate reports, taxes, and ensures compliance with financial regulations.",
    id: 6,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does QueueBuster's integration with payment platforms like Paytm
        improve payment processing, and what are the benefits for businesses?
      </span>
    ),
    des: "QueueBuster integrated with Paytm offers secure payments, multiple payment options, streamlined processing, and enhances operational efficiency for businesses.",
    id: 7,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What customer loyalty features does integrating QueueBuster with
        Easyrewardz and Easyecom offer, and how does it drive repeat purchases?
      </span>
    ),
    des: "Integrating QueueBuster with Easyrewardz and Easyecom builds customer loyalty, creates personalized rewards, manages e-commerce stores, and analyzes customer behavior for optimized marketing strategies.",
    id: 8,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does QueueBuster's integration with enterprise solutions like
        Oracle, Unicommerce, and SAP benefit large-scale businesses, and what
        features does it offer?
      </span>
    ),
    des: "Integrating Oracle, Unicommerce, and SAP with QueueBuster streamlines operations, provides advanced analytics, improves efficiency, and offers industry-standard tools for seamless business processes.",
    id: 9,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What steps are involved in integrating QueueBuster with third-party
        software, and how does it ensure a smooth transition for businesses?
      </span>
    ),
    des: "Integrating QueueBuster with third-party software involves configuration, data syncing, testing, and training. It ensures a smooth transition by providing tailored integrations, support, and training resources for businesses.",
    id: 10,
    activeIndex: 0,
  },
];

export const paymentFaq = [
  {
    para: (
      <span style={{ width: "90%" }}>
        How secure are the payment transactions processed through QueueBuster's
        integrated payment solutions?
      </span>
    ),
    des: "QueueBuster ensures robust security measures, including encryption and fraud prevention tools, to safeguard payment transactions and protect businesses and customers from unauthorized access and fraud.",
    id: 1,
    activeIndex: 1,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        Can businesses customize their payment options based on their specific
        requirements with QueueBuster's integrated solutions?
      </span>
    ),
    des: "Yes, businesses can customize their payment options, analytics, and reporting tools with QueueBuster's integrated solutions, allowing them to cater to their unique needs and enhance their payment experience.",
    id: 2,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How quickly are payments settled with Paytm's payment gateway for
        businesses?
      </span>
    ),
    des: "Paytm's real-time bank settlement feature ensures that payments are settled promptly, providing businesses with efficient cash flow management and real-time visibility into their transactions.",
    id: 3,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What advantages does Razorpay offer in terms of payment modes for
        businesses?
      </span>
    ),
    des: "Razorpay provides businesses with access to a comprehensive range of payment modes, including credit cards, debit cards, net banking, UPI, and popular wallets, ensuring convenience and flexibility for both businesses and customers.",
    id: 4,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How do Ezetap's mobile POS solutions benefit businesses on the go?
      </span>
    ),
    des: "Ezetap's mobile POS solutions enable businesses to accept payments anywhere, anytime, providing flexibility and convenience for on-the-go transactions and enhancing customer experience.",
    id: 5,
    activeIndex: 0,
  },

  {
    para: (
      <span style={{ width: "90%" }}>
        What measures does Mosambee take to ensure secure contactless payments
        for businesses?
      </span>
    ),
    des: "Mosambee prioritizes security in contactless payments by implementing advanced encryption technologies and authentication protocols, ensuring safe and secure transactions for businesses and customers.",
    id: 6,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does Payswiff's fraud prevention feature help businesses protect
        against fraudulent transactions?
      </span>
    ),
    des: "Payswiff's fraud prevention tools utilize advanced algorithms and real-time monitoring to detect and prevent fraudulent transactions, safeguarding businesses from financial losses and reputational damage.",
    id: 7,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What level of customer support can businesses expect from integrated
        payment solutions providers like QueueBuster?
      </span>
    ),
    des: "Integrated payment solutions providers like QueueBuster offer 24x7 priority support via the Merchant Helpdesk, ensuring businesses receive prompt assistance and resolution for any payment-related issues or queries.",
    id: 8,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        How does PayPal's global reach benefit businesses with international
        customers?
      </span>
    ),
    des: "Paypal's global reach enables businesses to accept payments from international customers in multiple currencies, expanding their customer base and revenue opportunities globally.",
    id: 9,
    activeIndex: 0,
  },
  {
    para: (
      <span style={{ width: "90%" }}>
        What advantages do integrated payment solutions offer for businesses
        operating across multiple channels, including online, mobile, and POS
        systems?
      </span>
    ),
    des: "Integrated payment solutions like those offered by leading fintech brands provide businesses with omnichannel payment capabilities, fraud prevention measures, and dedicated customer support, enhancing operational efficiency and customer satisfaction across all channels.",
    id: 10,
    activeIndex: 0,
  },
];
